import type { LucideIcon } from 'lucide-react';

import { cn } from '../lib/utils';

import { Card } from './card';
import { Body, Subtitle } from './typography';

type EmptyStateProps = {
  icon: LucideIcon;
  title: string;
  description?: string;
  /** Extra classes on the Card wrapper — e.g. `max-w-md` to cap width in a wide panel. */
  className?: string;
};

/**
 * Empty/no-results state inside a tall Card with a centered icon, title and optional description.
 * Use when a list or panel has zero items. Renders a `Card padding="empty"`.
 */
export function EmptyState({ icon: Icon, title, description, className }: EmptyStateProps) {
  return (
    <Card
      padding="empty"
      className={cn('flex flex-col items-center justify-center text-center', className)}
    >
      <Icon className="size-12 text-muted-foreground/40" />
      <Body weight="medium" tone="muted" className="mt-4">
        {title}
      </Body>
      {description && <Subtitle className="mt-1">{description}</Subtitle>}
    </Card>
  );
}

export type { EmptyStateProps };
